<template lang="pug">
Button(
    view="secondary"
    :icon="'icon-shareAlt_outline'"
    @click="share"
) Отправить
            
</template>

<script lang="ts">
import Vue, { computed } from 'vue'

import { sendAppEventWithRetry } from '@/packages/namba-metrics'

import { QrForDownload } from '@/widgets/QrForDownload'

import { Button } from '@/shared/ui/Button'
import { useIsOnlyQrLayout } from '@/shared/lib/hooks/useIsOnlyQrLayout'

import { getQrImage } from '@/feature/get-qr-image'
let cacheFile: Maybe<File> = null
const timeout: Maybe<ReturnType<typeof setTimeout>> = null

export default Vue.extend({
    name: 'ButtonShareLink',
    setup() {
        const { isOnlyQrLayout } = useIsOnlyQrLayout()

        async function share() {
            clearTimeout(timeout!)
            try {
                await sendAppEventWithRetry({
                    name: 'qrCodeShareButtonClick',
                })

                let file: Maybe<File> = cacheFile
                if (!file) {
                    const { file: newFile } = await getQrImage()
                    if (newFile) {
                        file = newFile
                        cacheFile = newFile
                    }
                }

                if (file) {
                    await navigator.share({
                        files: [file],
                    })
                }
            } catch (err) {
                console.log(err)
            }
        }

        const text = computed(() => {
            return isOnlyQrLayout.value ? 'Скопировать QR-код' : 'Скопировать'
        })

        return {
            share,
            text,
        }
    },
    components: {
        QrForDownload,
        Button,
    },
})
</script>
